<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/offer/details/', projectId, offerId]">Zurück zum Angebot</a>
    </li>
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/offers']">Übersicht</a>
    </li>
  </ul>
</nav>

<main>
  <h2 class="mb1em">PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Offer {{ projectId }}.0003.{{ offerId }} bearbeiten</h2>
  <app-offer-form
    *ngIf="offers"
    [projectId]="projectId"
    [offerId]="offerId"
    [offersData]="offers[0]"
    [isUpdateMode]="true">
  </app-offer-form>
</main>

<pre *ngIf="devMode" class="datepicker-output">
  <p>Offers:</p>
    {{ offers | json }}
</pre>
